/** The request `cache` holds under `key`, else the one `send` starts,
 * held there until it fails. Every caller asking while it is pending or
 * after it resolved shares the one promise. A failed request drops its
 * entry, unless a newer request under `key` has taken its place. */
export function sharedRequest<T>(
  cache: Map<string, Promise<T>>, key: string, send: () => Promise<T>,
): Promise<T> {
  const cached = cache.get(key);
  if (cached) {
    return cached;
  }
  const sent = send();
  sent.catch(() => {
    if (cache.get(key) === sent) {
      cache.delete(key);
    }
  });
  cache.set(key, sent);
  return sent;
}
